import { css } from '@emotion/react'
import { ComponentPropsWithoutRef } from 'react'

import { LogoStacked } from '@/features/logo'
import { mq } from '@/theme/mixins'
import { colors } from '@/theme/variables'

type Props = ComponentPropsWithoutRef<'footer'>

export const Footer = ({ ...props }: Props) => {
  const styles = {
    footer: css`
      display: grid;
      align-items: flex-start;
      background: ${colors.gray20};
      padding: var(--row-54) var(--margin) var(--row-72);
      grid-template-columns: 1fr auto auto;
      column-gap: var(--gtr-72);
      color: #fff;
      ${mq().m} {
        grid-template-columns: 1fr 1fr;
      }
      ${mq().s} {
        grid-template-columns: 1fr;
      }
    `,
    logo: css`
      height: var(--fs-108);
      ${mq().m} {
        grid-column: 1 / -1;
        margin-bottom: 1em;
        justify-self: center;
      }
      ${mq().s} {
        justify-self: flex-start;
      }
    `,
    column: css`
      margin-top: 1.5em;
      display: grid;
      justify-items: flex-start;
      row-gap: 0.75em;
    `,
    link: css`
      display: block;
      color: #fff;
      text-decoration: none;
      max-width: fit-content;
      @media (hover: hover) {
        &:hover {
          color: ${colors.greenLight};
        }
      }
    `,
    heading: css`
      font-size: var(--fs-18);
      text-transform: uppercase;
      color: #ffffff88;
      margin: 0 0 -0.25em;
    `,
  }
  return (
    <footer
      css={styles.footer}
      {...props}
    >
      <LogoStacked css={styles.logo} />
      <div css={styles.column}>
        <a
          css={styles.link}
          href="tel:0"
          target="tel:8008462562"
          rel="noreferrer"
        >
          (800) 846-2562
        </a>
        <a
          css={styles.link}
          href="mailto:marketing@wellbornforest.com"
          target="_blank"
          rel="noreferrer"
        >
          marketing@wellbornforest.com
        </a>
        <a
          href="https://maps.app.goo.gl/vnqYW6FyQ3xF2XT97"
          target={'_blank'}
          rel={'noreferrer'}
          css={styles.link}
        >
          2212 Airport Blvd, <br />
          Alexander City, AL 35010
        </a>
      </div>
      <div css={styles.column}>
        <h2 css={styles.heading}>Hours</h2>
        <div>
          7:30am – 4:15pm CST <br />
          Monday – Friday <br />
          Closed on Holidays
        </div>
      </div>
    </footer>
  )
}
